import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "centered w100",
  style: {"padding-top":"10px"}
}
const _hoisted_2 = {
  class: "mc",
  style: {"width":"450px"}
}
const _hoisted_3 = {
  key: 0,
  class: "with_white_bg",
  style: {"padding":"15px 25px 20px"}
}
const _hoisted_4 = { class: "fs13 fw400 text-left" }
const _hoisted_5 = {
  class: "fs18 fw600 text-left",
  style: {"color":"#222222","padding-bottom":"13px","line-height":"1.6"}
}
const _hoisted_6 = {
  key: 1,
  class: "with_white_bg",
  style: {"width":"450px"}
}
const _hoisted_7 = {
  key: 0,
  class: "text-center fs13 pad10 centered",
  style: {"color":"#666","background":"#ffe8bd"}
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "arial pad10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "w100 fw600 fs12 pointer rad6 pad4 whiteColor mc",
  style: {"background":"#fd7b5e","width":"130px"}
}, " ダウロードはこちら ", -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  align: "left",
  valign: "top",
  width: "400",
  style: {"padding":"20px","color":"#666"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "カレンダー連携している場合には、同期しているカレンダーにお送りします。", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "詳細な情報は以下から調整ページで確認できます。", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, " ※ 確定した内容を再調整/キャンセルしたい場合は、 調整ページのページ上部にあります「再調整・キャンセルしたい」をご利用いただくか、 ページオーナーにチャットでお問い合わせください。 ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "その他、出席者に伝えたい内容は、調整ページ内にあるチャットでやりとりできます。", -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { key: 2 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", {
  align: "left",
  valign: "top",
  width: "400",
  style: {"padding":"20px 20px 0","color":"#666"}
}, [
  /*#__PURE__*/_createElementVNode("p", null, "以下から調整ページに入り、日程を確認できます。")
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  class: "w100",
  style: {"background":"#fff","padding-top":"5px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MailPreviewPartsHeader = _resolveComponent("MailPreviewPartsHeader")!
  const _component_MailPreviewSenderIconContent = _resolveComponent("MailPreviewSenderIconContent")!
  const _component_MailPreviewPartsEditContent = _resolveComponent("MailPreviewPartsEditContent")!
  const _component_MailPreviewPartsPublicRoomTable = _resolveComponent("MailPreviewPartsPublicRoomTable")!
  const _component_MailPreviewPartsSelectableMags = _resolveComponent("MailPreviewPartsSelectableMags")!
  const _component_MailPreviewPartsBlueButton = _resolveComponent("MailPreviewPartsBlueButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MailPreviewPartsHeader),
      _createVNode(_component_MailPreviewSenderIconContent, {
        member: _ctx.member,
        message: `様が日程を確定しました`
      }, null, 8, ["member"]),
      (_ctx.rcm.selectedMailFlow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.member ? _ctx.member.company_name : `○○株式会社`), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.member ? _ctx.member.name : "●●") + " 様 ", 1)
            ]),
            _createVNode(_component_MailPreviewPartsEditContent, { onAddMessage: _ctx.addMessage }, null, 8, ["onAddMessage"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.rm.userInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.Util.isPresent(_ctx.rcm.room_setting.attachment_files))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rcm.room_setting.attachment_files, (af, afindex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "centered mc",
                      key: afindex
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/file_with_clip.png`),
                        height: "60",
                        width: "60",
                        class: "mc"
                      }, null, 8, _hoisted_8),
                      _createElementVNode("div", _hoisted_9, [
                        _createTextVNode(_toDisplayString(_ctx.truncate(af.original_filename, 40)), 1),
                        _hoisted_10,
                        _createTextVNode(" (" + _toDisplayString(af.file_size) + ") ", 1)
                      ]),
                      _hoisted_11
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_MailPreviewPartsPublicRoomTable, {
              showFixedAppo: true,
              showAnswerResults: _ctx.rcm.selectedMailFlow.show_qa
            }, null, 8, ["showAnswerResults"]),
            (_ctx.rcm.room && _ctx.rcm.room.room_type == `parent_room`)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                  _createElementVNode("td", _hoisted_13, [
                    _hoisted_14,
                    _hoisted_15,
                    (_ctx.rcm.room_setting.use_chat && _ctx.rcm.room_setting.available_cancel_min_before_appo_start_time == -1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("tr", _hoisted_20, _hoisted_22))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_MailPreviewPartsSelectableMags, { isFix: true }),
        _createVNode(_component_MailPreviewPartsBlueButton, {
          buttonName: _ctx.rcm.room && _ctx.rcm.room.room_type == `parent_room` ? `調整ページへ` : `調整ページへ`
        }, null, 8, ["buttonName"])
      ])
    ])
  ]))
}